import ValidService from "../../../service/ValidService";
let model = {};

// dữ liệu form
model.dataForm = {
  name: null, // required - Tên văn bản
  template_config_id: null, // optional - Mẫu cấu hình
  template_category_id: null, // optional - Phân loại mẫu cấu hình
  code: null, // required, maxLength: 50 - Ký hiệu
  type: null, // optional, enum(EXTERNAL_DOC_IN, EXTERNAL_DOC_OUT, INTERNAL_DOC) - Loại văn bản ĐẾN/ĐI
  book_number: null, // required - Số đến
  business_id: null,
  publish: { // optional - Thông tin ban hành
    publishers: null, // optional
    publish_status: null, // optional, enum(NEW, PUBLISHED, REJECTED) - Trạng thái ban hành
    "content": null, // optional - Nội dung ban hành
    "is_auto": null, // required - Có tự động ban hành không
    "publisher_to_ids": [], // optional
    "publish_at": null, // optional - Thời điểm ban hành
    "publisher_id": null, // optional - Người ban hành
    "position": // optional - Vị trí ký
    {
      "x": null, // optional
      "y": null, // optional
      "page_index": null, // optional
    },
    "status": null, // optional, enum(PUBLISHING, PUBLISHED, PUBLISHED_FAILED)
    "published_file_id": null, // optional, ref: mushroom_file - File đã ban hành
    "sign_image_id": null, // optional, ref: mushroom_file - Ảnh chữ ký
    "department_id": null, // optional, ref: department - Nơi ban hành
  },
  description: null, // optional - Trích yếu
  company_id: null, // optional, ref: company - Mã công ty
  source: {
    sources_id: null, // optional, ref: organization_model - Đơn vị gửi
    sources_name: null, // optional - Tên đơn vị
    type: null, // optional - Loại
  },
  author_id: null, // required, ref: mushroom_user - Người gửi
  sent_at_from: null, // required - Ngày gửi
  sent_at_to: null, // required - Ngày gửi
  document_category_id: null, // optional, ref: document_category - Loại văn bản
  document_category_name: null, // optional - Tên văn bản
  process_type: null, // optional, enum(ALL, MAIN_PROCESS, MIX_PROCESS, GET_FEEDBACK) - Loại xử lý
  urgency_id: null, // optional, ref: document_category - Độ khẩn
  secret_id: null, // optional, ref: document_category - Độ mật
  book: {
    book_id: null, // optional, ref: book - Số sổ văn bản Id
    book_name: null, // optional - Số văn bản
    book_number: null, // optional - Sổ đến
    book_date: null, // optional - Ngày vào sổ
  }, // optional - Thông tin sổ
  other_files: [], // optional - Danh sách file - array of IdRef
  doc_file:  // required - File văn bản
  {
    doc_id: null, // required, ref: mushroom_file - File văn bản
    capacity: null, // optional - Dung lượng (MB)
    type: null, // optional - Loại file pdf, doc..
  },
  readers: [
    // {
    //   employee_id: null, // optional, ref: mushroom_user
    //   read_at: null, // optional
    // }
  ], // optional - Những người đọc văn bản này
  signers: Array(), // optional - Người ký
  deadline: null, // optional - Thời hạn xử lý
  status: null, // required,  enum(NEW, WAITING_FOR_SIGN, SIGNED, REJECTED, PUBLISHED) - Trạng thái (Mới, Chờ ký, Đã ký, Từ chối, Xuất bản)
  // comments: null,
  comments: {
    comment_id: null, // required, ref: mushroom_user - Người cho ý kiến
    position_id: null, // optional, ref: position - Chức vụ Id
    position_name: null, // optional - Chức vụ
    organization_model_id: null, // optional, ref: organization_model - Đơn vị Id
    organization_model_name: null, // optional - Đơn vị
    content: null, // optional - Nội dung ý kiến
    comment_date: null, // optional - Ngày ý kiến
  }, // optional - Danh sách ý kiến
  transfer: {
    content: null, // required - Nội dung chỉ đạo
    recall_note: null, // optional - Lý do thu hồi
    working_units: [
      {
        organization_model_id: null, // required, ref: organization_model - Đơn vị Id
        organization_model_name: null, // optional - Đơn vị
        has_process: null, // optional - Có phải xử lý hay không
        is_transfer_all: null, // optional - Có chuyển cho tất cả cá nhân trong đơn vị
        status: null, // optional, enum(NO_PROCESS, PROCESSED) - Trạng thái xử lý ( Chưa xử lý | Đã xử lý)
        is_recall: null, // optional - Đã thu hồi
      }
    ], // optional - array of object
    persons: [
      {
        person_id: null, // required, ref: mushroom_user - Người nhận
        person_name: null, // optional - Người nhận
        position_id: null, // optional, ref: position - Chức vụ Id
        position_name: null, // optional - Chức vụ
        organization_model_id: null, // optional, ref: organization_model - Đơn vị Id
        organization_model_name: null, // optional - Đơn vị
        status: null, // optional, enum(CHUA_XU_LY, DA_XU_LY) - Trạng thái xử lý
        is_recall: null, // optional - Đã thu hồi
        person_comment: null, // optional - Đã thu hồi
      }
    ], // optional
  }, // optional - Danh sách nhận văn bản
  disabled: false, // required - Đã bị khóa chưa
  person_comment: null, // optional - Đã thu hồi
  effected_date: {
    start_effected_at: null, // optional - Thời điểm bắt đầu hiệu lực
    end_effected_at: null, // optional - Thời điểm hết hiệu lực
    is_has_effected_after_signed: null, // optional - Có hiệu lực sau khi ký
  },
  "more_info": {
    "identity": undefined, // optional - Mã định danh cơ quan
    "history_archive": undefined, // optional - Cơ quan lưu trữ lịch sử
    "history_archive_code": undefined, // optional - Mã cơ quan lưu trữ lịch sử
    "font_family": undefined, // optional - Font
    "table_of_contents": undefined, // optional - Mục lục
    "doc_year_formation": undefined, // optional - Năm hình thành hồ sơ
    "shelf_life_time": undefined, // optional - Thời hạn bảo quản
    "usage_mode": undefined, // optional - Chế độ sử dụng
    "language": undefined, // optional - Ngôn ngữ
    "depository_unit": undefined, // optional - Đơn vị nộp lưu
    "file_classification": undefined, // optional - Phân loại hồ sơ
    "start_time": undefined, // optional - Thời gian bắt đầu
    "end_time": undefined, // optional - Thời gian kết thúc
    "doc_file_count": undefined, // optional - Tổng số văn bản trong hồ sơ
    "info_symbol": undefined, // optional - Ký hiệu thông tin
    "key_words": undefined, // optional - Từ khóa
    "number_of_sheets": undefined, // optional - Số lượng tờ
    "number_of_pages": undefined, // optional - Số lượng trang
    "physical_status": undefined, // optional - Tình trạng vật lý
    "note": undefined, // optional - Chú giải
    "barcode": undefined, // optional - Mã barcode
    "storage": undefined, // optional - Kho lưu trữ
    "folder_save": undefined, // optional - Folder lưu trữ
    "location_save": undefined, // optional - Vị trí lưu
    "year_save": undefined, // optional - Năm lưu trữ
    "number_of_year_save": undefined, // optional - Số năm lưu trữ
    "shelf": undefined, // optional - Gía, kệ,
    "bag": undefined, //Hộp, cặp
  },
};

// validation form
model.validForm = {
  name: [ValidService.required, ValidService.checkSpaceString],
  document_category_id: [ValidService.requiredChange],
  code: [ValidService.required, ValidService.checkSpaceStringCenter, ValidService.checkMaxLength(255), ValidService.checkVietNameseHaveNumber],
  book_number: [ValidService.required, ValidService.checkSpaceStringCenter, ValidService.checkMaxLength(255)],
  business_id: [ValidService.requiredChange],
  sent_at_from: [ValidService.requiredChange],
  publish_at_from: [ValidService.requiredChange],
  description: [ValidService.required, ValidService.checkSpaceString],
  source: {
    sources_id: [ValidService.requiredChange],
    type: [ValidService.requiredChange]
  },
  book: {
    book_id: [ValidService.requiredChange], // optional, ref: book - Số sổ văn bản Id
  },
  person_comment: [ValidService.required], // optional - Đã thu hồi
  signers: [
    // {
    //   user_id: [ValidService.requiredChange],
    //   position_id: [ValidService.requiredChange],
    // }
  ], // optional - Người ký
  effected_date: {
    start_effected_at: [ValidService.requiredChange], // optional - Thời điểm bắt đầu hiệu lực
  },
};

model.dataFormDocumentMoreInformation = {
  "identity": undefined, // optional - Mã định danh cơ quan
  "history_archive": undefined, // optional - Cơ quan lưu trữ lịch sử
  "history_archive_code": undefined, // optional - Mã cơ quan lưu trữ lịch sử
  "font_family": undefined, // optional - Font
  "table_of_contents": undefined, // optional - Mục lục
  "doc_year_formation": undefined, // optional - Năm hình thành hồ sơ
  "shelf_life_time": undefined, // optional - Thời hạn bảo quản
  "usage_mode": undefined, // optional - Chế độ sử dụng
  "language": undefined, // optional - Ngôn ngữ
  "depository_unit": undefined, // optional - Đơn vị nộp lưu
  "file_classification": undefined, // optional - Phân loại hồ sơ
  "start_time": undefined, // optional - Thời gian bắt đầu
  "end_time": undefined, // optional - Thời gian kết thúc
  "doc_file_count": undefined, // optional - Tổng số văn bản trong hồ sơ
  "info_symbol": undefined, // optional - Ký hiệu thông tin
  "key_words": undefined, // optional - Từ khóa
  "number_of_sheets": undefined, // optional - Số lượng tờ
  "number_of_pages": undefined, // optional - Số lượng trang
  "physical_status": undefined, // optional - Tình trạng vật lý
  "note": undefined, // optional - Chú giải
  "barcode": undefined, // optional - Mã barcode
  "storage": undefined, // optional - Kho lưu trữ
  "folder_save": undefined, // optional - Folder lưu trữ
  "location_save": undefined, // optional - Vị trí lưu
  "year_save": undefined, // optional - Năm lưu trữ
  "number_of_year_save": undefined, // optional - Số năm lưu trữ
  "shelf": undefined, // optional - Gía, kệ
  "bag": undefined, //Hộp, cặp
}

model.dataFormTransfer = {
  transfer: {
    content: null,
    // recall_note: null,
  },
};

model.validFormTransfer = {
  transfer: {
    content: [ValidService.required],
    // recall_note: [ValidService.required], // optional - Lý do thu hồi
  },
};

model.dataFormRecall = {
  transfer: {
    recall_note: null,
  },
}

model.validFormRecall = {
  transfer: {
    recall_note: [ValidService.required],
  },
};

model.dataFormRejectSign = {
  rejectReason: null,
}

model.validFormRejectSign = {
  rejectReason: [ValidService.required, ValidService.checkSpaceString],
};

model.dataFormEditBookNumber = {
  newBookNumber: null,
}

model.validFormEditBookNumber = {
  newBookNumber: [ValidService.required, ValidService.checkSpaceStringCenter, ValidService.checkMaxLength(255)],
};

model.dataFormTransferToOtherCompany = {
  text_search_company: null,
  other_company_id: null,
  employee_id: null,
  content: null,
  transfer_ids: null,
}

model.validFormTransferToOtherCompany = {
  text_search_company: [ValidService.required, ValidService.checkMinLength(1)],
  other_company_id: [ValidService.requiredChange],
  content: [ValidService.required, ValidService.checkSpaceString, ValidService.checkMaxLength(2000)],
};

model.dataFormVTOtherCompany = {
  text_search_person: null,
}

model.validFormVTOtherCompany = {
  text_search_person: [ValidService.required, ValidService.checkMinLength(1)],
};

model.listFileSizeOperator = [
  {
    label: 'Lớn hơn',
    value: '>',
  },
  {
    label: 'Nhỏ hơn',
    value: '<',
  }
];

model.listFileSizeType = [
  {
    label: 'KB',
    value: 'KB'
  },
  {
    label: 'MB',
    value: 'MB'
  },
  {
    label: 'Byte',
    value: 'B'
  },
];

model.listDocDuration = [
  {
    label: '1 ngày',
    value: '1d'
  },
  {
    label: '3 ngày',
    value: '3d'
  },
  {
    label: '1 tuần',
    value: '1w'
  },
  {
    label: '2 tuần',
    value: '2w'
  },
  {
    label: '1 tháng',
    value: '1m'
  },
  {
    label: '2 tháng',
    value: '2m'
  },
  {
    label: '6 tháng',
    value: '6m'
  },
  {
    label: '1 năm',
    value: '1y'
  },
];

model.listDocContent = [
  {
    label: 'Tất cả văn bản',
    value: ''
  },
  {
    label: 'Văn bản đến',
    value: 'VBI'
  },
  {
    label: 'Văn bản đi',
    value: 'VBO'
  },
  {
    label: 'Trình ký',
    value: 'TK'
  },
  {
    label: 'Ký duyệt',
    value: 'KD'
  },
  {
    label: 'Ký nháy',
    value: 'N'
  },
];

model.listDocStatus = [
  {
    label: 'Mới',
    value: 'DOC_NEW'
  },
  {
    label: 'Chờ ký duyệt',
    value: 'DOC_WAITING'
  },
  {
    label: 'Chờ ký nháy',
    value: 'DOC_DRAFF_WAITING'
  },
  {
    label: 'Từ chối ký duyệt',
    value: 'DOC_REJECTED'
  },
  {
    label: 'Từ chối ký nháy',
    value: 'DOC_DRAFF_REJECTED'
  },
  {
    label: 'Hủy trình ký',
    value: 'DOC_REJECT_FOR_SIGN'
  },
  {
    label: 'Đã ký duyệt',
    value: 'DOC_SIGNED'
  },
  {
    label: 'Đã ký nháy',
    value: 'DOC_DRAFF_SIGNED'
  },
  {
    label: 'Đã ban hành',
    value: 'DOC_PUBLISHED'
  },
  {
    label: 'Đã thu hồi',
    value: 'DOC_RECALLED'
  },
];

model.listReadStatus = [
  {
    label: 'Tất cả',
    value: ''
  },
  {
    label: 'Đã đọc',
    value: 'true'
  },
  {
    label: 'Chưa đọc',
    value: 'false'
  },
],

model.tableRules = {
  data: [],
  lengthMenu: [10, 20, 50, 100],
  allowPaging: true,
  allowSorting: true,
  allowSelect: false,
  showFormSearch: false,
  showUrl: true,
  total: 0,
  page: 1,
  limit: 10,
  offset: 0,
  sort: '-created_at',
  defaultSort: ['created_at', 'descending'],
  filters: '',
  recordSelected: [],
  dataSearch: {
    value: {
      text_search: undefined,
      from_id : undefined,
      to_id : undefined,
      name: undefined,
      include_word_find: undefined,
      exclude_word_find: undefined,
      operator_str: undefined,
      capacity: undefined,
      unit: undefined,
      time_about: undefined,
      date: undefined,
      type: undefined,
      has_attach_file: undefined,
      limit: undefined,
      skip: undefined,
      status: undefined,
      is_read: undefined,
    },
    valid: {
      text_search: [],
      from_id : [],
      to_id : [],
      name: [],
      include_word_find: [],
      exclude_word_find: [],
      operator_str: [],
      capacity: [],
      unit: [],
      time_about: [],
      date: [],
      type: [],
      has_attach_file: [],
      limit: [],
      skip: [],
      status: [],
      is_read: [],
    },
    operator: {
      text_search: '',
      from_id : '',
      to_id : '',
      name: '',
      include_word_find: '',
      exclude_word_find: '',
      operator_str: '',
      capacity: '',
      unit: '',
      time_about: '',
      date: '',
      type: '',
      has_attach_file: '',
      limit: '',
      skip: '',
      status: '',
      is_read: '',
    }
  }
};

export default model;
